var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React from "react";
import { Checkbox } from "@atlaskit/checkbox";
var NoneName = "None";
var Classifications = function (_a) {
    var selected = _a.selected, setSelected = _a.setSelected, classificationList = _a.classificationList;
    return (React.createElement("div", { className: "Classifications" }, classificationList.map(function (c) { return (React.createElement(Checkbox, { key: c.name, label: c.name, isChecked: selected.includes(c.name), onChange: function (e) {
            if (e.target.checked) {
                if (c.name === NoneName) {
                    setSelected([NoneName]);
                }
                else {
                    setSelected(__spreadArrays(selected).concat(c.name));
                }
            }
            else {
                setSelected(selected.filter(function (c2) { return c2 !== c.name; }));
            }
        }, isDisabled: 
        // Allow user to select EITHER "None" _or_ multiple classifications.  This logic disables the opposite.
        // If nothing has been selected, then all checkboxes should be enabled.
        (selected.length === 1 &&
            selected[0] === NoneName &&
            c.name !== NoneName) ||
            (selected.length > 0 && !selected.includes(NoneName) && c.name === NoneName) })); })));
};
export default Classifications;
